import React from 'react';

/**
 * Small circular progress indicator (donut chart) for percentages.
 * @param {Object} props
 * @param {number} props.value - Percentage value 0-100.
 * @param {number} [props.size] - Diameter in pixels (default 24).
 * @param {string} [props.color] - Stroke color (default uses accent-orange).
 */
export default function CircularProgress({ value, size = 24, color = '#ff6b00' }) {
  const strokeWidth = 3;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(value, 100) / 100) * circumference;

  return (
    <svg width={size} height={size} className="circular-progress">
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="rgba(255,255,255,0.1)"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
}
